
import { computed, defineComponent, onMounted, onUnmounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import AppLayout from "./layout/AppLayout.vue";
// import messaging from "./services/firebase";
import { useStore } from "@/store";
import { AuthMutationTypes } from "./store/modules/auth/mutations";
import GlobalProgressSpinner from "@/components/common/GlobalProgressSpinner.vue";
import { mapGetters } from "vuex";
import { AuthActionTypes } from "./store/modules/auth/actions";
import Scroll from "@/components/common/Scroll.vue";

export default defineComponent({
  setup() {
    const { t: l } = useI18n();
    const store = useStore();
    const isLoading = ref(true);

    const width = ref(window.innerWidth);

    const handleResize = () => {
      width.value = window.innerWidth;
    };

    onMounted(async () => {
      window.addEventListener("resize", handleResize);
      const token = localStorage.getItem("access");
      // console.log("Token", token);
      if (token) {
        store.commit(AuthMutationTypes.SET_TOKEN, token);
        try {
          await store.dispatch(AuthActionTypes.GET_ACCOUNT_INFO);

          const role = store.getters.getAccountInfo?.RoleName;
          if (!!role && role !== "Users" && process.env.NODE_ENV === "production") {
            localStorage.removeItem("access");
            window.location.href = `/${process.env.VUE_APP_SUB_URL}`;
          }
        } catch (e) {
          console.warn(e);
        }
      }
      isLoading.value = false;
    });
    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });
    const isLargerMin = computed(() => width.value > 347);

    return {
      // token,
      isLargerMin,
      isLoading,
      l,
    };
  },
  components: {
    AppLayout,
    GlobalProgressSpinner,
    Scroll,
  },
  computed: {
    ...mapGetters(["getGlobalLoading"]),
  },
});
